<template>

      <div style="width:50rem;">
      <div class="flex justify-between">

       <div>
            <el-input size="small" v-model="keywords" placeholder="输入单号|卡号查询" style="width:15rem;" maxlength="30" clearable /> <el-button  color="#626aef" plain @click="searchKeywordsFun" size="small" >查询</el-button>
       </div>
            <el-pagination sm layout="prev, pager, next"
            :page-size="pageSize" :current-page="currentPage" :total="total" v-if="total>0" @current-change="directPage"
            > </el-pagination>

      </div>
            <div  style="height:20rem;" class="mt-2">

 <el-empty description="记录列表为空" v-if="recordList.length==0"></el-empty>

         <template v-for="(record,idx) in recordList">

          <div class="relative float-left pt-1 pb-1 pl-1 pr-1 mb-2 mr-2 border-2 w-80 h-96">
              <div class="text-lg text-center">{{record.sub_title}}</div>
              <div class="m-2 text-sm">
                  <span class="text-gray-400 ">单号</span>
                  <span class="pl-1">{{record.bill_id}}</span>
              </div>
              <div class="m-2 text-sm">
                  <span class="text-gray-400 ">时间</span>
                  <span  class="pl-1">{{record.oper_time}}</span>
              </div>
                <div class="m-2 text-sm">
                  <span class="text-gray-400 ">收银</span>
                  <span  class="pl-1">{{record.oper_user_name}}</span>
              </div>

               <div class="m-2 text-sm">
                  <span class="text-gray-400 ">卡号</span>
                  <span  class="pl-1">{{record.card_code}}</span>
              </div>
               <div class="m-2 text-sm">
                  <span class="text-gray-400 ">扣款</span>
                  <span  class="pl-1">{{record.trade_amount}}</span>
              </div>

                 <div class="m-2 text-sm">
                  <span class="text-gray-400 ">余额</span>
                  <span  class="pl-1">{{record.balance_amount}}</span>
              </div>
                <div class="m-2 text-sm">
                  <span class="text-gray-400 ">说明</span>
                  <span  class="pl-1">关联单号{{record.relate_bill_code}}</span>
              </div>

                <div class="absolute bottom-0 flex items-center justify-between w-full px-5 py-3 text-lg">
                    <div class="text-yellow-700 cursor-pointer "  @click="redWriteFun(record.bill_id)" v-if="record.redwrite_id=='0'"  >
                         <i class="iconfont icon-guanbi"></i>
                         <span  class="pl-1">红冲</span>
                     </div>
 <div class="text-sm text-yellow-700 "  v-if="record.redwrite_id!='0'" >
                       {{record.redwrite_id==record.bill_id?'已红冲':'红冲'+record.redwrite_id}}
                     </div>
                    <div class="text-green-700 cursor-pointer " @click="beforeOperConsumeBillFun(record.bill_id)" v-if="record.redwrite_id=='0'" >
                        <i class="iconfont icon-xiugai"></i>
                        <span  class="pl-1">修改</span>
                     </div>

                    <div class="text-gray-700 cursor-pointer " @click="printAgain(record.print_id)">
                    <i class="iconfont icon-dayin"></i>
                    <span class="pl-1">打印</span>
                    </div>
                </div>

          </div>

          </template>

            </div>
    </div>

   <el-dialog
    title="修改关联单号"
    v-model="showView"
    width="340px"
    :before-close="handleClose"
    :show-close="false"
  >

    <div class="">
      <div>
         单号:{{billID}}
      </div>
      <el-radio-group v-model="relateBillCodePrefix">
          <el-radio :label="1">MR</el-radio>
          <el-radio :label="2">QX</el-radio>
          <el-radio :label="3">零售</el-radio>
           <el-radio :label="4">处理商品</el-radio>
        </el-radio-group>
         <el-input size="small" v-model="relateBillCode" placeholder="输入单号" style="width:15rem;" maxlength="30" clearable />
    </div>
    <template #footer>
      <span class="flex items-center justify-end dialog-footer">
       <el-button @click="operConsumeBillFun">确 定</el-button>
        <el-button @click="beforeOperConsumeBillFun">取 消</el-button>
      </span>
    </template>
  </el-dialog>

</template>
<script>
import { reactive, ref, toRefs } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { getRecordList, operConsumeBill, operRedWrite } from '@/utils/record.js'
import { noticePrint } from '@/utils/pos.js'
export default {
  name: 'n03',
  setup () {
    const keywords = ref('')
    const recordList = ref([])

    const pageSize = ref(2)
    const currentPage = ref(1)
    const total = ref(0)

    const directPage = (idx) => {
      currentPage.value = idx
      searchFun()
    }
    const searchFun = () => {
      getRecordList(3, {
        keywords: keywords.value.replace(/\s+/g, ''),
        offset: currentPage.value,
        limit: pageSize.value
      }, (res) => {
        total.value = res.total
        recordList.value = res.rows
      })
    }
    const searchKeywordsFun = () => {
      currentPage.value = 1
      searchFun()
    }

    const printAgain = (print_id) => {
      noticePrint(print_id, () => {
        ElMessage({
          showClose: true,
          message: '打印请求成功',
          type: 'success'
        })
      })
    }

    const currentDate = new Date()

    const operBillCode = reactive({
      showView: false,
      beforeOperConsumeBillFun: (_billID) => {
        operBillCode.showView = !operBillCode.showView
        operBillCode.billID = _billID
      },
      operConsumeBillFun: () => {
        operConsumeBill({
          flag: 1,
          bill_id: operBillCode.billID,
          relate_id: (operBillCode.relateBillCodePrefix === 3 ? 'LS' : (operBillCode.relateBillCodePrefix === 4 ? 'CL' : (operBillCode.relateBillCodePrefix === 1 ? 'MR' : 'QX'))) + operBillCode.relateBillCode
        }, (res) => {
          ElMessage({
            showClose: true,
            message: '修改成功',
            type: 'success'
          })

          operBillCode.showView = false
          searchFun()
        })
      },
      relateBillCode: ref('00' + currentDate.getFullYear() + (currentDate.getMonth() + 101).toString().substring(1) +
   (currentDate.getDate() + 100).toString().substring(1)),
      relateBillCodePrefix: 1,
      billID: '',
      handleClose: () => {}
    })

    const redWriteFun = (billID) => {
      ElMessageBox.confirm(
        '是否确定红冲记录' + billID + '?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        }
      ).then(() => {
        operRedWrite(3, {
          flag: 0,
          bill_id: billID
        }, () => {
          ElMessage({
            showClose: true,
            message: '记录红冲成功',
            type: 'success'
          })
          setTimeout(() => {
            searchKeywordsFun()
          }, 1000)
        })
      })
    }

    searchFun()

    return {
      recordList,
      pageSize,
      total,
      currentPage,
      directPage,
      searchFun,
      searchKeywordsFun,
      keywords,
      printAgain,
      ...toRefs(operBillCode),
      redWriteFun
    }
  }
}
</script>
<style scoped>

</style>
